export const ROUTE_PATHS = {
  HOME: '/',
  MEMBER_LOGIN: '/member-login',
  MEMBER_DASHBOARD: '/member-dashboard',
  MEMBER_ZONE: '/member-zone',
  ANNOUNCEMENT: '/announcement',
  ORG_CHART: '/org-chart'
} as const;

export interface NavItem {
  label: string;
  href: string;
}

export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  excerpt: string;
  image: string;
}

export interface CoreValue {
  id: string;
  icon: string;
  title: string;
  description: string;
}

export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export interface JoinStep {
  id: string;
  step: number;
  title: string;
  description: string;
}

export interface AnnouncementImage {
  url: string;
  order: number;
  filename: string;
}

export interface Announcement {
  id: string;
  title: string;
  content: string;
  images: AnnouncementImage[];
  published: boolean;
  created_at: string;
  updated_at: string;
}